export default {
  reviewRequests: {
    filteredRecords: 0,
    items: [],
    bulkScheduleRunning: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: 'purchase_timestamp',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
      send: true,
    },
  },
  reviewRequestsPerMonth: {
    data: {},
    loaded: false,
  },
};
